<template>
    <div>
        <compWrapper :title="$t('erp.b2border.salesman_information',{defaultValue:'销售员信息'})" theme="primary">
			<compFormQuery v-if="type=='query'" :formdata="getBase" :value="formData" :labelWidth="120"></compFormQuery>
			<compFormEdit v-else class="margin-15 clearfix" ref="editform" :formdata="getBase" v-model="formData" :labelWidth="120" />
            <div v-if="type!='query'" class="text-right margin-right-15">
                <vButton theme="primary" @click="submit">{{$t('global.common.save',{defaultValue:'保存'})}}</vButton>
                <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operate_cancel',{defaultValue:'取消'})}}</vButton>
            </div>
        </compWrapper>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapState,mapGetters,mapMutations } from "vuex";

import { HttpGetSalesmanOne,HttpSaveSalesmanOne } from "@/service/manage/manage";
export default {
    props:['activeids','querytype'],
    components: {
		// compWrapper: () => import("@components/templates/wrapper"),
		// compFormQuery: () => import("@components/templates/formquery"),
		// compFormEdit: () => import("@components/templates/formedit"),
        // compLog: () => import("./log"),
	},
    data(){
        return {
            id: this.$route.query.id,
            type: this.$route.params.type,
            formData:{
                channelsArr:"",
                commissionRate:0,
            },
            loading:false
        }
    },
    created(){
        this.update()
    },
    computed:{
        ...mapGetters('diction',['getNewAccountList']),
        getBase(){
            return [
                {
					label: this.$t('erp.b2border.name',{defaultValue:'名'}),
                    key: "lastName",
                    query:this.type != 'add'
                },
                {
					label: this.$t('erp.b2border.surname',{defaultValue:'姓'}),
                    key: "firstName",
                    query:this.type != 'add'
                },
                {
					label: this.$t('global.common.email',{defaultValue:'邮箱'}),
                    key: "email",
                    query:this.type != 'add'
                },
                {
					label: this.$t('erp.b2c.phone',{defaultValue:'电话'}),
					key: "telephone",
				},
                {
					label: this.$t('global.common.channel',{defaultValue:'渠道'}),
                    key: "channelsArr",
                    required:false,
					tag: 'vSelect',
					options: this.getNewAccountList,
					props: {
                        filterable: true,
                        clearable:true,
                        multiple:true,
					}
				},
				{
					label: this.$t('erp.b2border.percentage',{defaultValue:'佣金百分比(%)'}),
                    key: "commissionRate",
                    tag:'vInputNumber',
                    required:false,
                    on:{
                        'on-change':(val)=>{
                            this.numberChange(val)
                        }
                    }
				},
            ]
        }
    },
    methods:{
        ...mapMutations('diction', ['clearStore']),
        numberChange(VauleNumber){
            let newNumber= null
            if (VauleNumber >= 0) {
                let reg = /.*\..*/
                if (reg.test(VauleNumber)) {
                newNumber= parseFloat(VauleNumber.toFixed(2))
                } else {
                newNumber = VauleNumber
                }
            }
            // console.log(newNumber)
            this.formData.commissionRate = newNumber
            this.$set(this.formData,'commissionRate',newNumber)
            // console.log(this.formData.commissionRate,'ererer')
            // return newNumber
        },
        update(){
            if(this.type == 'add') return
            if(this.activeids){
                this.id = this.activeids
                this.type = this.querytype
            }else{
                this.id = this.id
                this.type = this.type
            }
            HttpGetSalesmanOne({
                id:this.id
            }).then(res=>{
                this.formData = res.data
                let arr = res.data.channels.split(",") || ""
                if(arr[0]!=""){
                    this.formData.channelsArr = arr
                }else{
                    this.formData.channelsArr = ''
                }
                // console.log(this.formData.channelsArr,'渠道')
            },err=>{

            })
        },
        async submit(){
            let bool1 = await this.$refs.editform.validate()
			if (!bool1) return
            this.formData.channels = this.formData.channelsArr.join(",");
            this.loading=true;
            HttpSaveSalesmanOne({
                ...this.formData,
                orgId:global.SYSID,
            }).then(res=>{
                this.loading=false;
                this.clearStore('allSalesList');
                this.$VMessage.success(res.message)
                this.cancel()
            },err=>{
                this.loading=false;
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$router.push({
                name: 'salesmanmanage',
            });
        }
    },
}
</script>